import AdvanceHistoryDetails from 'features/advance/screens/manageAdvanceAccount/AdvanceHistory/AdvanceHistoryDetails/AdvanceHistoryDetails';
import React from 'react';

export default function AdvanceHistoryDetailPage() {
  return <AdvanceHistoryDetails />;
}
